import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    Chip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ onToggleMenu }) => {

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
                backdropFilter: 'blur(10px)'
            }}
        >
            <Toolbar sx={{minHeight: '80px', px: 4}}>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                    <IconButton
                        onClick={onToggleMenu}
                        sx={{
                            color: '#2563eb',
                            '&:hover': {
                                backgroundColor: 'rgba(37, 99, 235, 0.1)',
                                color: '#1d4ed8'
                            },
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        <MenuIcon sx={{fontSize: '2rem'}}/>
                    </IconButton>
                    <Box>
                        <Typography
                            variant="h5"
                            sx={{
                                fontFamily: '"Inter", "Roboto", sans-serif',
                                fontWeight: 700,
                                letterSpacing: '-0.025em',
                                color: '#1e293b',
                                lineHeight: 1.2
                            }}
                        >
                            EndoLink
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                color: '#64748b',
                                fontSize: '0.75rem',
                                fontWeight: 500,
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase'
                            }}
                        >
                            Linguistic Research Platform
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{flexGrow: 1}}/>

                <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                    <Chip
                        label="Beta"
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            borderRadius: 2
                        }}
                    />
                    <img
                        src={`${process.env.PUBLIC_URL}/uzh_logo.png`}
                        alt="University of Zurich"
                        style={{
                            height: '48px',
                            filter: 'grayscale(30%)',
                            transition: 'filter 0.2s ease-in-out'
                        }}
                        onMouseEnter={(e) => e.target.style.filter = 'grayscale(0%)'}
                        onMouseLeave={(e) => e.target.style.filter = 'grayscale(30%)'}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
